import {Observable} from 'rxjs/Observable'
import {DataService} from 'core/data/service'

export class PbmFuncionalService extends DataService {

  
// @Path("/funcional/consulta-preco")
postConsultaPreco(pbmData) {
  console.log('postConsultaPreco')
  const data = this.buildPreAutorizacao(pbmData);
  const options = {
    method: 'POST',
    url: '/pbm/funcional/consulta-preco',
    data: data
  };
  return Observable.fromPromise(super.request(options))
}

// @Path("/funcional/consulta-preco/cadastro-unico")
postCadastroUnico(pbmData) {
  const options = {
    method: 'POST',
    url: '/pbm/funcional/consulta-preco/cadastro-unico',
    data: pbmData
  };
  return Observable.fromPromise(super.request(options))
}

// @Path("/funcional/pre-autorizacao")
  preAutorizacao(preAutorizacao){
    const data = this.buildPreAutorizacao(preAutorizacao);

    const options = {
        method: 'POST',
        url: "/pbm/funcional/pre-autorizacao",
        data: data
    }

    return Observable
            .fromPromise(super.request(options));
  }


  
  buildPreAutorizacao(data) {
    let preAutoriazacao = {
      "cartaoBeneficiario": data.nroCartao,
      "cpfBeneficiario": data.nroCpf,
      "codigoPrograma": data.sequenciaPrograma,
      "codigoConvenio": data.codigoConvenio,
      "codigoAdminConvenio": data.codigoAdminConvenio,
      "sequenciaPrograma": data.sequenciaPrograma,
      "itens": [
        {
          "codigoItem": data.item,
          "quantidadeSolicitada": data.quantidadeSolicitada
        }
      ]
    }
    return preAutoriazacao;
  }


}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-funcional/pbm-funcional.service.js